import createActionHelper from './createActionHelper';
import {
  REGISTER_FETCH_ENTITY,
  FETCH,
  SET_FETCH_ENTITY_RESPONSE,
  SET_FETCH_ENTITY_LOADING,
  SET_FETCH_ENTITY_ERROR,
  LOGIN,
} from '../constants/fetch';

export function registerFetchEntity(id, options) {
  return createActionHelper(REGISTER_FETCH_ENTITY)({
    id,
    options,
  });
}

export function fetch(id, url, options, mapper) {
  return createActionHelper(FETCH)({
    id,
    url,
    options,
    mapper,
  });
}

export function setFetchEntityResponse(id, response) {
  return createActionHelper(SET_FETCH_ENTITY_RESPONSE)({
    id,
    response,
  });
}

export function setFetchEntityLoading(id, loading) {
  return createActionHelper(SET_FETCH_ENTITY_LOADING)({ id, loading });
}

export function setFetchEntityError(id, error) {
  return createActionHelper(SET_FETCH_ENTITY_ERROR)({ id, error });
}

export function login(body, options = {}) {
  return createActionHelper(LOGIN)({ body, ...options });
}
